import { useEffect, useState } from "react";

import Pages from "./pages";
import PagesLang from "./pagesLang";
import Blocks from "./blocks";
import BlocksLang from "./blocksLang";
import MasterBlocks from "./masterBlocks";
import Editor from "./editor";
import app from "../components/app";
import Users from "./users";
import Dashboard from "./dashboard";
import Live from "./live";
import HtmlEditor from "./htmlEditor";
import Plugin, { vibeDeletePage } from "./plugin";
import Preview from "./preview";
import Migration from "./migration";
import RealPreview from "./realPreview";
import LanguageSettings from "./languageSettings";
import Quiz from "./quiz";
import Templates from "./templates";
import FeaturePages from "./featurePages";

import {NotAllow} from "../components/helpers";

import AppLogs from "./appLogs";
import Themes from "./themes";
import HeaderFooterSave from "./headerFooterSave";
import RepairPages from "./repairPages";
import PreviewSkill from "./previewSkill";




const visitors = [
    "2f74a7dc0fd0c3d9d09d9f46ea173520", // Ravi
    "86902882c2160eccb1264c0789818eac", // Chrome
    "03cb5b7cc69b54cce921ed5c683f1215", // Safari
    "d97fcdd6e79c315ea424f587886c914e", //Mozzila
    "62ae9dd3fadaf1256bca4943c0939481",
    "16e87782ee6ba4b9d301f9ab37168749",
    "e72d66cb1f77cd8faa7216d82bfb039c",
    "fff05440ca2482c80308a3dc1094aa19"
]

const visitorsIP = ["118.185.108.246", "118.185.108.245", "49.249.114.78"]

const getMatch = function() {
    const [page, category, subcategory] = window.location.pathname.split("/").filter(function(v){
        if(v.trim() === "") {
            return false;
        }
        return true;
    })
    return { page, category, subcategory };
}


export default function Index() {
    const [match, setMatch] = useState(getMatch());
    const [isAllow, setIsAllow] = useState(false);
    const [ip, setIP] = useState("");
    const [visitorId, setVisitorId] = useState("");

    useEffect(() => {
        window.getScreenshot = app.getScreenshot;
        // Registered here rather than in the Plugin component because the host
        // page deletes pages from the normal editor route, where <Plugin /> is
        // not mounted. Same host->app pattern as window.saveAILogo /
        // window.headerFooterHTML in src/pages/divKit.js.
        window.vibeDeletePage = vibeDeletePage;
        if(document.querySelector("#ai-editor")) {
            document.querySelector("#ai-editor").classList.add(`language-${app.appLang()}`);
        }
        if(app.checkDivkit()) {
            document.querySelector("#ai-editor").classList.add(`appkit-editor`);
            document.querySelector("#ai-editor").classList.add(`appkit-${app.isProject()}`);
        }
        
        app.loadConfig()
        window.addEventListener("popstate", popState);
        window.routerClick = routerClick;
        window.pushState = pushState;
        fetch("https://api-fetch.mediadirhub.com/fingerprint").then(function(response){
            response.json().then(function(response){
                if(visitors.indexOf(response.data.visitorId) !==  -1) {
                    setIsAllow(true);
                    setVisitorId(response.data.visitorId);
                    setIP(response.data.ip)
                }
                else {
                    setVisitorId(response.data.visitorId);
                    setIP(response.data.ip)
                }
            })
        });

    }, []);
    
    const popState = function() {
        setMatch(getMatch())
    }
    const pushState = function(page, category, subcategory) {
        if(subcategory) {
            window.history.pushState({page, category, subcategory}, "", `/${page}/${category}/${subcategory}`);
        }
        else if(category) {
            window.history.pushState({page, category, subcategory}, "", `/${page}/${category}`);
        }
        else if(page) {
            window.history.pushState({page, category, subcategory}, "", `/${page}`);
        }
        else {
            window.history.pushState({page, category, subcategory}, "", `/`);
        }
        setMatch({ page, category, subcategory })
    }
    const routerClick = function(event) {
        const href = event.currentTarget.getAttribute("href");
        if(href  === "/") {
            pushState();
        }
        else {
            const [page, category, subcategory] = href.split("/").filter(function(v){
                if(v.trim() === "") {
                    return false;
                }
                return true;
            })
            pushState(page, category, subcategory);
        }
        event.preventDefault();
    }
    if(app.getProject() === "pages") {
        if(isAllow) {
            if(match.page === "mobile-preview") {
                return <RealPreview category={match.category} device="mobile" subcategory={match.subcategory} />
            }
            else if(match.page === "desktop-preview") {
                return <RealPreview category={match.category} device="desktop" subcategory={match.subcategory} />
            }
            return <Users page={match.page} category={match.category} />
        }
        return <NotAllow visitorId={visitorId} />
    }
    else if(app.getProject() === "live") {
        if(app.checkPlugin()) {
            return <Plugin />
        }
        if(app.checkHtmlEditor()) {
            return <HtmlEditor />
        }
        return <Live />
    }
    else if(app.getProject() === "templates") {
        if(visitorsIP.indexOf(ip) === -1) {
            return <div className="w3-display-middle" style={{position:"fixed", left:"50%", top:"50%", textAlign:"center", transform:"translate(-50%, -50%)"}}>
  <h1 className="w3-jumbo w3-animate-top w3-center"><code style={{color:"red", fontSize:"36px", fontWeight:"bold"}}>Access Denied</code></h1>
  <hr className="w3-border-white w3-animate-left" style={{margin: 'auto', width: '50%'}} />
  <h3 className="w3-center w3-animate-right">You dont have permission to view this site.</h3>
  <h3 className="w3-center w3-animate-zoom">🚫🚫🚫🚫</h3>
  <h6 className="w3-center w3-animate-zoom">error code:403 forbidden</h6>
</div>
;
        }
        if(match.page === "feature-pages") {
            return <FeaturePages category={match.category} subcategory={match.subcategory} />
        }
        return <Templates category={match.category} subcategory={match.subcategory} />
    }
    else {
        if(visitorsIP.indexOf(ip) === -1) {
            return <div className="w3-display-middle" style={{position:"fixed", left:"50%", top:"50%", textAlign:"center", transform:"translate(-50%, -50%)"}}>
  <h1 className="w3-jumbo w3-animate-top w3-center"><code style={{color:"red", fontSize:"36px", fontWeight:"bold"}}>Access Denied</code></h1>
  <hr className="w3-border-white w3-animate-left" style={{margin: 'auto', width: '50%'}} />
  <h3 className="w3-center w3-animate-right">You dont have permission to view this site.</h3>
  <h3 className="w3-center w3-animate-zoom">🚫🚫🚫🚫</h3>
  <h6 className="w3-center w3-animate-zoom">error code:403 forbidden</h6>
</div>
;
        }
        if(match.page === "pages") {
            if(match.subcategory) {
                if(match.subcategory === "preview") {
                    return <Preview type="pages" id={match.category} />
                }
                else if(match.subcategory === "lang") {
                    return <PagesLang category={match.category} />
                }
                else {
                    return <div className="w-100 p-2">No Preview Found</div>
                }
            }
            return <Pages category={match.category} subcategory={match.subcategory} />
        }
        else if(match.page === "themes") {
            return <Themes category={match.category} subcategory={match.subcategory} />
        }
        else if(match.page === "language-settings") {
            return <LanguageSettings category={match.category} subcategory={match.subcategory} />
        }
        else if(match.page === "header-footer") {
            return <HeaderFooterSave category={match.category} subcategory={match.subcategory} />
        }
        else if(match.page === "repair-pages") {
            return <RepairPages category={match.category} subcategory={match.subcategory} />
        }
        else if(match.page === "feature-pages") {
            return <FeaturePages category={match.category} subcategory={match.subcategory} />
        }
        else if(match.page === "blocks") {
            if(match.subcategory) {
                return <BlocksLang category={match.category} />
            }
            return <Blocks category={match.category} />
        }
        else if(match.page === "master-blocks") {
            return <MasterBlocks category={match.category} />
        }
        else if(match.page === "mobile-preview") {
            return <RealPreview category={match.category} device="mobile" subcategory={match.subcategory} />
        }
        else if(match.page === "desktop-preview") {
            return <RealPreview category={match.category} device="desktop" subcategory={match.subcategory} />
        }
        else if(match.page === "migration") {
            return <Migration category={match.category} />
        }
        else if(match.page === "quiz") {
            return <Quiz category={match.category} />
        }
        else if(match.page === "app-logs") {
            return <AppLogs category={match.category} />
        }
        else if(match.page === "preview-skill") {
            return <PreviewSkill />
        }
        return <Dashboard />
    }
}